<confirm-code>
  <style>
  .bold {
    font-weight: bold;
  }
  ul.attention li {
    margin-left: 1em;
  }
    ul.attention{
      width: 77%;
      margin: 2em auto 0 auto;
    }
  </style>
  <section class="sec-top-function com-bg-gray">
    <div class="sec-top-inner sec-inner">
      <header class="sec-top-header">
        <h2 class="sec-top__ttl"><span>認証コード入力</span></h2>
        <p if={mail}>{mail}に認証コードが記載されたメールを送信しました。</p>
        <p>メールに記載された認証コードを入力してください。</p>

      </header>
    </div>
  </section>


  <div class="com-article-inner">
    <div class="sec-inner">
      <div class="sec-basic-input__wrap com-bg-white">
        <section class="sec-basic-input">

          <div class="com-form">
            <form>
              <div class="com-form__item__content">
                <div class="com-form__item__input input-text">
                  <input type="text" name="code" data="{data}" is="edireco-binding" validate="string" placeholder="認証コードを入力してください" errMsg="認証コードを入力してください" required>
                </div>
              </div>


              <div class="com-form__submit">
                <button type="button" class="com-btn-01" onclick="{dump}" if={!isLoading}><span>認証</span></button>
              </div>

            </form>
          </div>

          <ul class="attention">
            <li>メールが届かない場合は、迷惑メールのフォルダやメールアドレスの入力を再度お試しください</li>
            <li>認証コードは1時間有効です。時間を超過した場合はやり直してください</li>
            <li>やり直した場合は有効時間内であっても古い認証コードは無効となります <a href="/register" class="bold">はじめから</a></li>
          </ul>

        </section>
        <!-- End .sec-basic-input -->
      </div>
    </div>
  </div>
  <script>
    import di from 'dependeny-injection'

    export default {
      mail: di.register.masked_mail,
      data: di.register.codeData,
      isLoading: false,
      onMounted(){
        scrollTo(0, 0);
        if (di.register.secondCode !== false) {
          di.route.router.push("/input-information");
          return;
        }
        this.mail = di.register.masked_mail || false;
        this.update();
      },
      dump(e) {
        e.preventDefault();

        if (this.data.validate()) {
          di.register.changeLoaderState(true, this, 'isLoading');
          di.register.api('/confirm-code', this.data.toData())
            .then((data) => {
              di.register.changeLoaderState(false, this, 'isLoading');
              if (data.status) {
                di.register.masked_mail = data.masked_mail;
                di.register.secondCode = data.secondCode;
                di.route.router.push("/input-information");
              } else {
                this.data.trigger('valid:code', false, data.message)
              }
            })
        }
      }
    }
  </script>
</confirm-code>
